import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  projectsList: [], 
  projectArr: [],
  projectArray: [],
  projectID: '',
  selectedSupervisor: null,
  selectedProject: null,
  selectedBranch: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.projectsList = [];
    state.projectArr = [];
    state.projectArray = [];
    state.ProjectID = "";
    state.selectedSupervisor = null;
    state.selectedProject = null;
    state.selectedBranch = null;
    state.isEditing = false;
  },
  SET_SELECTED_PROJECT(state, project) {
    state.selectedProject = project;
    state.isEditing = true;
  },
  LIST_PROJECTS(state,projects) {
    state.projectsList = projects;
  },
  PROJECTS_ARRAY(state, projects){
    state.projectArray = projects;
  },
  SET_SELECTED_SUPERVISOR(state, supervisor) {
    state.selectedSupervisor = supervisor;
  },
  SET_SELECTED_BRANCH(state, branch) {
    state.selectedBranch = branch;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createProject({ commit,state }, formData) {
    return axios.post('api/v1/create-project/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      throw error;
    })
  },

  fetchProjects({ commit,state }, formData) {
    state.projectArr = [];
    axios.post(`api/v1/get-projects/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.projectArr.push((response.data[i].name ));
      }
      commit('LIST_PROJECTS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchProject({ commit,state }, formData) {
    axios.post(`api/v1/get-projects/`,formData)
    .then((response)=>{
      state.selectedProject = response.data;
      const selectedBranch = (response.data.branch != null) ? (response.data.branch.name) : "";
      commit('SET_SELECTED_SUPERVISOR',(response.data.supervisor != null) ? (response.data.supervisor.first_name + " "+ response.data.supervisor.last_name + " - " + response.data.supervisor.email) : "");
      commit('SET_SELECTED_BRANCH', selectedBranch);
      commit('SET_SELECTED_PROJECT',response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedProject({ commit, state }, option){
    const selectedProject = state.projectsList.find(project => (project.name ) === option);
    if (selectedProject) {
        state.projectID = selectedProject.project_id;
        state.projectArray = [...state.projectArray, selectedProject];
    }
    commit('PROJECTS_ARRAY', state.projectArray);
      
  },
  async updateProject({ commit,state }, formData) {
    return axios.put(`api/v1/update-project/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteProject({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Project?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Project!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-project/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Project removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Project",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Project has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  